module.exports = __webpack_public_path__ + "caminhao-tanque.94a13401c001b1351c0530daa7834465.jpg";